import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { getListJalurJenis, getListUnitkerja } from "@/services/getData"
import { JalurJenis, Unitkerja } from "@/types"
import { ChevronRight } from "lucide-react"
import React, { useState } from "react"
import { LuListFilter } from "react-icons/lu"
import { useQuery } from "@tanstack/react-query"
import { useNavigate, useSearchParams } from "react-router-dom"

export default function FormFilter({ closeModal }: { closeModal: () => void }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const idsRefJalurJenis = searchParams.get("ids_ref_jalur_jenis")
  const idsUk = searchParams.get("ids_uk")
  const statusValidasi = searchParams.get("status_validasi")
  const statusBayarPendaftaran = searchParams.get("status_bayar_pendaftaran")
  const statusValidasiPenunjangUkt = searchParams.get(
    "status_validasi_penunjang_ukt"
  )
  const statusKelulusan = searchParams.get("status_kelulusan")
  const statusDaftarkembali = searchParams.get("status_daftarkembali")

  const [searchQueryProdi, setSearchQueryProdi] = useState("")
  const [selectedFilter, setSelectedFilter] = useState("JALUR")
  const [filter, setFilter] = useState<{
    jalur_jenis: string[]
    program_studi: string[]
    status_validasi: string
    status_bayar_pendaftaran: string
    status_kelulusan: string
    status_daftarkembali: string
    status_validasi_penunjang_ukt: string
  }>({
    jalur_jenis: idsRefJalurJenis?.split("-") || [],
    program_studi: idsUk?.split("-") || [],
    status_validasi: statusValidasi || "",
    status_bayar_pendaftaran: statusBayarPendaftaran || "",
    status_kelulusan: statusKelulusan || "",
    status_daftarkembali: statusDaftarkembali || "",
    status_validasi_penunjang_ukt: statusValidasiPenunjangUkt || "",
  })

  const { data: listJalurJenis, isPending: isPendingListJalurJenis } = useQuery(
    {
      queryKey: ["listJalurJenis"],
      queryFn: getListJalurJenis,
    }
  )

  const { data: listUnitkerja, isPending: isPendingListUnitkerja } = useQuery({
    queryKey: ["listUnitkerja"],
    queryFn: getListUnitkerja,
  })
  const listProdi = listUnitkerja?.filter((unitkerja: Unitkerja) => {
    return unitkerja.unitkerja_group_key == "5" && unitkerja.is_active
  })
  const filteredListProdi = listProdi
    ? listProdi.filter((prodi: Unitkerja) => {
        return prodi?.nama
          ?.toLowerCase()
          .includes(searchQueryProdi.toLowerCase())
      })
    : []

  const handleApplyFilter = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (filter.jalur_jenis.length > 0) {
      searchParams.set("ids_ref_jalur_jenis", filter.jalur_jenis.join("-"))
    } else {
      searchParams.delete("ids_ref_jalur_jenis")
    }

    if (filter.program_studi.length > 0) {
      searchParams.set("ids_uk", filter.program_studi.join("-"))
    } else {
      searchParams.delete("ids_uk")
    }

    if (filter.status_validasi.length > 0) {
      searchParams.set("status_validasi", filter.status_validasi)
    } else {
      searchParams.delete("status_validasi")
    }

    if (filter.status_bayar_pendaftaran.length > 0) {
      searchParams.set(
        "status_bayar_pendaftaran",
        filter.status_bayar_pendaftaran
      )
    } else {
      searchParams.delete("status_bayar_pendaftaran")
    }

    if (filter.status_validasi_penunjang_ukt.length > 0) {
      searchParams.set(
        "status_validasi_penunjang_ukt",
        filter.status_validasi_penunjang_ukt
      )
    } else {
      searchParams.delete("status_validasi_penunjang_ukt")
    }

    if (filter.status_kelulusan.length > 0) {
      searchParams.set("status_kelulusan", filter.status_kelulusan)
    } else {
      searchParams.delete("status_kelulusan")
    }

    if (filter.status_daftarkembali.length > 0) {
      searchParams.set("status_daftarkembali", filter.status_daftarkembali)
    } else {
      searchParams.delete("status_daftarkembali")
    }

    closeModal()
    navigate(`/admin/data-pendaftaran?${searchParams.toString()}`)
  }

  return (
    <form
      onSubmit={handleApplyFilter}
      className="pb-20 relative flex flex-col gap-y-3"
    >
      <FormHeader title="Filter Data Pendaftaran" icon={<LuListFilter />} />

      <section className="p-3 relative border rounded-xl flex flex-col gap-y-3">
        <span className="font-bold">Status</span>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_validasi == "0"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_validasi: checked ? "0" : "",
                }))
              }
            />
            <Label>Belum Validasi Pendaftaran</Label>
          </div>
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_validasi == "1"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_validasi: checked ? "1" : "",
                }))
              }
            />
            <Label>Sudah Validasi Pendaftaran</Label>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_bayar_pendaftaran == "0"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_bayar_pendaftaran: checked ? "0" : "",
                }))
              }
            />
            <Label>Belum Bayar Pendaftaran</Label>
          </div>
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_bayar_pendaftaran == "1"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_bayar_pendaftaran: checked ? "1" : "",
                }))
              }
            />
            <Label>Sudah Bayar Pendaftaran</Label>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_validasi_penunjang_ukt == "0"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_validasi_penunjang_ukt: checked ? "0" : "",
                }))
              }
            />
            <Label>Belum Validasi Penunjang UKT</Label>
          </div>
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_validasi_penunjang_ukt == "1"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_validasi_penunjang_ukt: checked ? "1" : "",
                }))
              }
            />
            <Label>Sudah Validasi Penunjang UKT</Label>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_kelulusan == "0"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_kelulusan: checked ? "0" : "",
                }))
              }
            />
            <Label>Belum Lulus</Label>
          </div>
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_kelulusan == "1"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_kelulusan: checked ? "1" : "",
                }))
              }
            />
            <Label>Lulus</Label>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_daftarkembali == "0"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_daftarkembali: checked ? "0" : "",
                }))
              }
            />
            <Label>Belum Daftarkembali</Label>
          </div>
          <div className="flex items-center gap-3">
            <Checkbox
              checked={filter.status_daftarkembali == "1"}
              onCheckedChange={(checked) =>
                setFilter((prev) => ({
                  ...prev,
                  status_daftarkembali: checked ? "1" : "",
                }))
              }
            />
            <Label>Sudah Daftarkembali</Label>
          </div>
        </div>
      </section>

      <section className="p-3 relative border rounded-xl">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "JALUR" ? "" : "JALUR"))
          }
        >
          <span className="font-bold">Jalur</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "JALUR" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "JALUR" &&
          (isPendingListJalurJenis ? (
            "Loading..."
          ) : (
            <div className="mt-3 grid grid-cols-3 gap-5">
              {listJalurJenis?.map((jalurJenis: JalurJenis) => {
                const isChecked = filter.jalur_jenis.includes(
                  String(jalurJenis.id_ref_jalur_jenis)
                )

                return (
                  <div
                    key={jalurJenis.id_ref_jalur_jenis}
                    className="flex gap-3"
                  >
                    <Checkbox
                      checked={isChecked}
                      onCheckedChange={(checked) => {
                        setFilter((prev) => {
                          const updatedJalurJenis = [...prev.jalur_jenis]

                          if (checked) {
                            if (
                              !updatedJalurJenis.includes(
                                String(jalurJenis.id_ref_jalur_jenis)
                              )
                            ) {
                              updatedJalurJenis.push(
                                String(jalurJenis.id_ref_jalur_jenis)
                              )
                            }
                          } else {
                            const index = updatedJalurJenis.indexOf(
                              String(jalurJenis.id_ref_jalur_jenis)
                            )
                            if (index > -1) {
                              updatedJalurJenis.splice(index, 1)
                            }
                          }

                          return {
                            ...prev,
                            jalur_jenis: updatedJalurJenis,
                          }
                        })
                      }}
                    />
                    <Label>{jalurJenis.nama_jalur_jenis}</Label>
                  </div>
                )
              })}
            </div>
          ))}
      </section>

      <section className="p-3 relative border rounded-xl max-h-[30vh] overflow-auto">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "PRODI" ? "" : "PRODI"))
          }
        >
          <span className="font-bold">Program Studi</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "PRODI" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "PRODI" &&
          (isPendingListUnitkerja ? (
            "Loading..."
          ) : (
            <>
              <div className="py-3 sticky top-0">
                <Input
                  placeholder="Search..."
                  value={searchQueryProdi}
                  onChange={(event) => setSearchQueryProdi(event.target.value)}
                />
              </div>
              <div className="mt-3 grid grid-cols-2 gap-5">
                {filteredListProdi?.map((prodi: Unitkerja) => {
                  const isChecked = (filter.program_studi as string[]).includes(
                    String(prodi.uk_id)
                  )

                  return (
                    <div key={prodi.uk_id} className="flex gap-3">
                      <Checkbox
                        checked={isChecked}
                        onCheckedChange={(checked) => {
                          setFilter((prev) => {
                            const programStudi = [...prev.program_studi]

                            if (checked) {
                              if (!programStudi.includes(String(prodi.uk_id))) {
                                programStudi.push(String(prodi.uk_id))
                              }
                            } else {
                              const index = programStudi.indexOf(
                                String(prodi.uk_id)
                              )
                              if (index > -1) {
                                programStudi.splice(index, 1)
                              }
                            }

                            return {
                              ...prev,
                              program_studi: programStudi,
                            }
                          })
                        }}
                      />
                      <Label>{prodi.nama}</Label>
                    </div>
                  )
                })}
              </div>
            </>
          ))}
      </section>

      <div className="absolute bottom-3 left-3 right-3">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <Button
              onClick={() => closeModal()}
              type="button"
              variant={"outline"}
            >
              Batal
            </Button>
            <Button>Terapkan Filter</Button>
          </div>
          <Button
            type="button"
            variant={"outline"}
            onClick={() => {
              setFilter((prev) => ({
                ...prev,
                jalur_jenis: [],
                program_studi: [],
                status_validasi: "",
                status_kelulusan: "",
                status_daftarkembali: "",
              }))
              closeModal()
              navigate("/admin/data-pendaftaran")
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </form>
  )
}
